import { Grid, Link, Switch, Typography } from "@mui/material";
import { useState } from "react";
import CallToAction from "src/components/core/CallToAction";
import { TwoFactorStyles } from "src/components/settings/profile/styles/TwoFactor.styles";
import { ActivationDialog } from "src/components/settings/profile/ActivationDialog";
import { DeactivationDialog } from "src/components/settings/profile/DeactivationDialog";
import { trackEvent } from "src/Amplitude";
import api from "src/store/features/api";

export default function TwoFactor() {
  const classes = TwoFactorStyles();
  const label = { inputProps: { "aria-label": "Enabled" } };
  const [selectedValue, setSelectedValue] = useState("1");
  const [deactivateTwoFaSelectedValue, setDeactivateTwoFaSelectedValue] = useState("1");
  const { data: user, isSuccess } = api.useGetUserDatav2Query();
  const { is2FAEnabled } = isSuccess ? user : { is2FAEnabled: false };
  //check if the user
  const [open, setOpen] = useState(false);
  const [openDiactivationDialog, setOpenDiactivationDialog] = useState(false);
  const link =
    "https://support.calebandbrown.com/en/articles/6082925-setting-up-two-factor-authentication-2fa";
  const warningMessage =
    "For your security Caleb & Brown asks you to enable two factor authentication (2FA). Once enabled you'll be able to lodge withdrawal requests, and add new addresses to your account. To learn more about 2FA and how to get started please click ";
  const handleClose = (value: string) => {
    setOpen(false);
    setOpenDiactivationDialog(false);
    setSelectedValue(value);
    setDeactivateTwoFaSelectedValue(value);
  };

  const handleClick = (event: any) => {
    trackEvent(
      "Button_Click",
      {
        button: "2FA_Switch",
      },
      "Two_Factor_Authentication",
    );
    setOpen(event.target.checked);
    // if (event.target.checked) getQrCode();
    if (!event.target.checked) {
      setOpenDiactivationDialog(true);
    }
  };
  return (
    <>
      {/* Warning component */}
      {!is2FAEnabled && (
        <Grid item xs={12} mb={2}>
          <CallToAction color="#fff3cc">
            <Grid
              item
              xs={12}
              style={{
                marginBottom: "10px",
              }}>
              <Typography style={{ fontWeight: 600, color: "#846403" }}>
                {warningMessage}
                <Link href={link} target="_blank">
                  here.
                </Link>
              </Typography>{" "}
            </Grid>
          </CallToAction>
        </Grid>
      )}
      {/* 2FA Switch */}
      <Grid container alignItems="center" className={classes.container}>
        <Grid item xs={12}>
          <Typography className={classes.heading}>Set Up 2FA</Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography>Enable 2 Factor Authentication</Typography>
        </Grid>

        <Grid item xs={4} className={classes.switch}>
          <Switch {...label} checked={is2FAEnabled} onClick={handleClick} />
        </Grid>
        <ActivationDialog selectedValue={selectedValue} open={open} onClose={handleClose} />
        <DeactivationDialog
          deactivateTwoFaSelectedValue={deactivateTwoFaSelectedValue}
          open={openDiactivationDialog}
          onClose={handleClose}
        />
      </Grid>
    </>
  );
}
